import AndieGenericToolRender from './AndieGenericToolRender';
import { useTranslation } from 'react-i18next';
import { ActionRenderAi } from '@/ai/types/action-render-ai';
import { AutoGraphRounded } from '@mui/icons-material';
import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { ActionResponseStatusAi } from '@/ai/enum/action-response-status-ai';
import { useAndieChatControls } from '@/providers/andie-chat-provider';

type ActionResponse = { id: string; name: string } | null;
type ActionArgs = { network?: string };

export type AndieOpenDemoDashboardProps = ActionRenderAi<ActionResponse, ActionArgs>;

const AndieOpenDemoDashboard = (props: AndieOpenDemoDashboardProps) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { agentNavigationPendingRef } = useAndieChatControls();
    const executingSteps = useRef<number>(0);

    useEffect(() => {
        if (props.status === ActionResponseStatusAi.EXECUTING) {
            executingSteps.current += 1;
        }

        // Demo dashboards render in demo mode automatically (the dashboard's isDemo flag), so navigating
        // to its route is all that's needed to show the sample data.
        if (
            props.status === ActionResponseStatusAi.COMPLETE &&
            props.result?.id &&
            executingSteps.current > 0
        ) {
            agentNavigationPendingRef.current = true;
            navigate('/dashboards/' + props.result.id);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.status]);

    return (
        <AndieGenericToolRender<ActionResponse, ActionArgs>
            title={() => t('andie.tool.open-demo-dashboard.title')}
            icon={<AutoGraphRounded fontSize="small" />}
            loadingMessages={() => [t('andie.tool.open-demo-dashboard.loading')]}
            completeMessage={({ result }) =>
                result?.name
                    ? t('andie.tool.open-demo-dashboard.complete', { name: result.name })
                    : t('andie.tool.open-demo-dashboard.complete-empty')
            }
            {...props}
        />
    );
};

export default AndieOpenDemoDashboard;
